import instanceAxios from "./intanceAxios";


export const classificationTaskService = {
    getClassificationTasks: async (params) => await instanceAxios.get('/otask/classifications/', { params }),
    createClassificationTask: async (data) => await instanceAxios.post('/otask/classifications/', data),
}